import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { moodColor } from "@/lib/api";

export default function MoodChart({ trend, dominantMood }) {
  const color = moodColor(dominantMood);
  const data = (trend || []).map((d) => ({
    date: d.date.slice(5), // MM-DD
    score: d.score,
    count: d.count,
    mood: d.mood,
  }));
  return (
    <div className="h-56" data-testid="mood-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="moodGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.5} />
              <stop offset="100%" stopColor={color} stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#E6E1D8" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="date"
            stroke="#5B6656"
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 11, fontFamily: "Manrope" }}
          />
          <YAxis
            domain={[-1, 1]}
            stroke="#5B6656"
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 11, fontFamily: "Manrope" }}
          />
          <Tooltip
            contentStyle={{
              background: "#FFFFFF",
              border: "1px solid #E6E1D8",
              borderRadius: 8,
              fontFamily: "Manrope",
              fontSize: 12,
            }}
            formatter={(value, _, p) => [
              `${value.toFixed(2)} (${p.payload.count} entries)`,
              p.payload.mood,
            ]}
          />
          <Area
            type="monotone"
            dataKey="score"
            stroke={color}
            strokeWidth={2}
            fill="url(#moodGrad)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
